import { Injectable, RendererFactory2 } from "@angular/core"
import { ReplaySubject } from "rxjs"

declare var window: any

export interface IWindowResizeEvent {
    isDesktop: boolean
    isSmallDesktop: boolean
    isTablet: boolean
    isSmallDevice: boolean
    isMobile: boolean
}

export enum ScreenBreakpoints {
    DesktopSmall = 1199,
    Tablet = 991,
    SmallDevice = 767,
    Phone = 576,
}

@Injectable()
export class WindowSizeService {
    public resize = new ReplaySubject<IWindowResizeEvent>(1)
    public isDesktop: boolean
    public isSmallDesktop: boolean
    public isTablet: boolean
    public isSmallDevice: boolean
    public isMobile: boolean

    constructor(private rendererFactory: RendererFactory2) {
        this.init()
    }

    private init() {
        this.updateBreakpointStatus()
        const renderer = this.rendererFactory.createRenderer(null, null)
        renderer.listen("window", "resize", () => {
            this.updateBreakpointStatus()
            this.notifyListeners()
        })
    }

    private updateBreakpointStatus() {
        this.isDesktop = window.innerWidth > ScreenBreakpoints.DesktopSmall
        this.isSmallDesktop = window.innerWidth <= ScreenBreakpoints.DesktopSmall
        this.isTablet = window.innerWidth <= ScreenBreakpoints.Tablet
        this.isSmallDevice = window.innerWidth <= ScreenBreakpoints.SmallDevice
        this.isMobile = window.innerWidth <= ScreenBreakpoints.Phone
    }

    private notifyListeners() {
        this.resize.next({
            isDesktop: this.isDesktop,
            isSmallDesktop: this.isSmallDesktop,
            isTablet: this.isTablet,
            isSmallDevice: this.isSmallDevice,
            isMobile: this.isMobile,
        })
    }
}
